import { LoaderCircleIcon } from '../../svg/loader-circle-icon';
import { cn } from '../../utils/cn';
import { InputGroupAddon } from '../input-group';

const BASE_STYLES =
  'bg-muted ring-2 ring-primary/20 text-muted-foreground absolute right-0 top-0 flex size-9 select-none items-center justify-center rounded-full p-0 cursor-progress';

interface LoadingAddonProps {
  className?: string;
  type?: 'input-group' | 'plain';
}

export function LoadingAddon({ type = 'input-group', className }: LoadingAddonProps) {
  if (type === 'input-group') {
    return (
      <InputGroupAddon className={cn(BASE_STYLES, className)}>
        <LoaderCircleIcon className="animate-spin" />
      </InputGroupAddon>
    );
  }

  return (
    <div className={cn(BASE_STYLES, className)}>
      <LoaderCircleIcon className="animate-spin" />
    </div>
  );
}
